import { Search, MapPin, Layers, Home } from "lucide-react";
import { Button } from "@/components/ui/button";

const ChevronDown = () => (
  <svg className="w-3.5 h-3.5 text-muted-foreground" fill="none" viewBox="0 0 24 24" stroke="currentColor">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
  </svg>
);

const SearchFilterThin = () => {
  return (
    <div
      className="w-full bg-card border border-border/70 shadow-[0_16px_36px_-18px_rgba(0,0,0,0.28)]"
      role="search"
      aria-label="Filter properties"
    >
      <div className="flex flex-col lg:flex-row items-stretch lg:items-center gap-0">
        {/* Location */}
        <div className="relative flex-1 border-b border-border/50 lg:border-b-0 lg:border-r lg:border-border/60">
          <div className="flex items-center gap-2 px-4 lg:px-5 min-h-[68px]">
            <MapPin className="w-4 h-4 text-accent shrink-0" strokeWidth={1.8} aria-hidden="true" />
            <select
              className="w-full appearance-none bg-transparent font-body text-[15px] text-foreground py-5 pr-7 rounded-sm cursor-pointer focus:outline-none focus-visible:ring-2 focus-visible:ring-accent/70 focus-visible:ring-offset-2 focus-visible:ring-offset-card"
              aria-label="Location"
            >
              <option>All Locations</option>
              <option>Boston, MA</option>
              <option>Cambridge, MA</option>
              <option>Cape Cod, MA</option>
              <option>Punta Cana, DR</option>
              <option>Santo Domingo, DR</option>
              <option>Las Terrenas, DR</option>
            </select>
            <div className="absolute right-4 lg:right-5 top-1/2 -translate-y-1/2 pointer-events-none">
              <ChevronDown />
            </div>
          </div>
        </div>

        {/* Category */}
        <div className="relative flex-1 border-b border-border/50 lg:border-b-0 lg:border-r lg:border-border/60">
          <div className="flex items-center gap-2 px-4 lg:px-5 min-h-[68px]">
            <Layers className="w-4 h-4 text-accent shrink-0" strokeWidth={1.8} aria-hidden="true" />
            <select
              className="w-full appearance-none bg-transparent font-body text-[15px] text-foreground py-5 pr-7 rounded-sm cursor-pointer focus:outline-none focus-visible:ring-2 focus-visible:ring-accent/70 focus-visible:ring-offset-2 focus-visible:ring-offset-card"
              aria-label="Category"
            >
              <option>All Categories</option>
              <option>Residential</option>
              <option>Investment</option>
              <option>Luxury</option>
              <option>New Development</option>
              <option>Commercial</option>
            </select>
            <div className="absolute right-4 lg:right-5 top-1/2 -translate-y-1/2 pointer-events-none">
              <ChevronDown />
            </div>
          </div>
        </div>

        {/* Property Type */}
        <div className="relative flex-1 border-b border-border/50 lg:border-b-0 lg:border-r lg:border-border/60">
          <div className="flex items-center gap-2 px-4 lg:px-5 min-h-[68px]">
            <Home className="w-4 h-4 text-accent shrink-0" strokeWidth={1.8} aria-hidden="true" />
            <select
              className="w-full appearance-none bg-transparent font-body text-[15px] text-foreground py-5 pr-7 rounded-sm cursor-pointer focus:outline-none focus-visible:ring-2 focus-visible:ring-accent/70 focus-visible:ring-offset-2 focus-visible:ring-offset-card"
              aria-label="Property Type"
            >
              <option>All Types</option>
              <option>Single Family</option>
              <option>Condo</option>
              <option>Townhouse</option>
              <option>Villa</option>
              <option>Penthouse</option>
              <option>Land</option>
            </select>
            <div className="absolute right-4 lg:right-5 top-1/2 -translate-y-1/2 pointer-events-none">
              <ChevronDown />
            </div>
          </div>
        </div>

        {/* Search Input */}
        <div className="relative flex-1 border-b border-border/50 lg:border-b-0">
          <div className="flex items-center gap-2 px-4 lg:px-5 min-h-[68px]">
            <Search className="w-4 h-4 text-muted-foreground shrink-0" strokeWidth={1.8} aria-hidden="true" />
            <input
              type="text"
              placeholder="Search by keyword..."
              className="w-full bg-transparent font-body text-[15px] text-foreground placeholder:text-muted-foreground py-5 rounded-sm focus:outline-none focus-visible:ring-2 focus-visible:ring-accent/70 focus-visible:ring-offset-2 focus-visible:ring-offset-card"
              aria-label="Search keyword"
            />
          </div>
        </div>

        {/* Search Button */}
        <div className="p-3 lg:p-0 lg:ml-0">
          <Button
            variant="gold"
            className="w-full lg:w-auto lg:min-w-[126px] gap-2 font-body text-[13px] uppercase tracking-[0.12em] font-semibold px-7 py-5 h-[56px] lg:h-[68px] rounded-none focus-visible:ring-2 focus-visible:ring-accent/70 focus-visible:ring-offset-2 focus-visible:ring-offset-card"
            aria-label="Search properties"
          >
            <Search className="w-3.5 h-3.5" aria-hidden="true" />
            Search
          </Button>
        </div>
      </div>
    </div>
  );
};

export default SearchFilterThin;
